import React from 'react'

import {
  ImageEditorEngine,
  ImageEditorMode,
  ImageEditorUiState,
} from '../image-editor.types'
import { LayersList } from './layers-list'
import { PanelAdjust } from './panel-adjust'
import { PanelCrop } from './panel-crop'
import { PanelInsert } from './panel-insert'
import { PanelSelected } from './panel-selected'

interface PanelProps {
  ui: ImageEditorUiState
  engine: ImageEditorEngine
}

const PANEL_HEADERS: Record<ImageEditorMode, { title: string; sub: string }> = {
  select: {
    title: 'Adjust & layers',
    sub: 'Adjust the photo, or click a layer',
  },
  crop: { title: 'Crop', sub: 'Trim to a region' },
  text: { title: 'Add text', sub: 'Click on the image to place' },
  draw: { title: 'Draw', sub: 'Freehand — becomes a layer' },
  shape: { title: 'Shape', sub: 'Drag to draw — becomes a layer' },
  sticker: { title: 'Stickers', sub: 'Click a sticker to drop it in' },
}

export function Panel({ ui, engine }: PanelProps) {
  const header = PANEL_HEADERS[ui.mode]

  return (
    <aside className="image-editor-panel shrink-0 touch-pan-y overflow-y-auto overscroll-y-contain bg-light-3 p-4">
      <h3 className="mb-1 text-base font-semibold">{header.title}</h3>
      <p className="mb-3.5 text-xs text-light-4">{header.sub}</p>

      {ui.mode === 'select' && ui.selected == null && (
        <PanelAdjust adjustments={ui.adjustments} engine={engine} />
      )}
      {ui.mode === 'select' && ui.selected != null && (
        <PanelSelected selected={ui.selected} engine={engine} />
      )}
      {ui.mode === 'crop' && <PanelCrop ui={ui} engine={engine} />}
      {(ui.mode === 'text' ||
        ui.mode === 'draw' ||
        ui.mode === 'shape' ||
        ui.mode === 'sticker') && <PanelInsert ui={ui} engine={engine} />}

      {ui.hasImage && <LayersList ui={ui} engine={engine} />}
    </aside>
  )
}
